import { css, SerializedStyles } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export

// not sure why this needs "important" on the margin to override typography
export const collapsibleHeader = (isExpanded: boolean): SerializedStyles => css`
  border: 1px solid ${variables.colour.neutral400};
  cursor: pointer;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 0px !important;
  ${isExpanded &&
  `
    border-radius: 5px 5px 0px 0px;
    border-bottom: none;
  `}
`;

export const collapsibleBody = css`
  border: 1px solid ${variables.colour.neutral400};
  border-radius: 0px 0px 5px 5px;
  // padding-top: 0px;
  padding: 10px;
`;
